import React from "react";

const BasePage: React.FC<{children: React.ReactNode}> = (props) => {
    return <div className="pageContainer">{props.children}</div>;
};

export default BasePage;
